import React from 'react';
import WorkspacePanelContainer from './WorkspacePanelContainer';

const WorkspacePanelFull = ({ code, workspaceUrl }) => (
  <WorkspacePanelContainer className="aridhia-workspace-panel-full panel-wizardible" code={code} url={workspaceUrl} />
);

export default WorkspacePanelFull;
